import React from 'react';
var TriggerContext = React.createContext(null);
export default TriggerContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-trigger@4.0.2@rc-trigger/es/context.js
// module id = 500
// module chunks = 0